const menu = document.querySelector('[js-menu]')
const menuBtn = document.querySelector('[js-menu-btn]')
const time = 600

const state = {
  isTablet: window.innerWidth < 1024,
  isOpen: false
}

let timer = null

// Close menu --------
function close() {
  menu.classList.remove('is-open')
  menuBtn.classList.remove('is-open')

  timer = setTimeout(() => {
    document.documentElement.style.overflow = 'auto'
    state.isOpen = false
    menu.style.display = 'none'
  }, time)
}

// Open menu --------
function open() {
  document.documentElement.style.overflow = 'hidden'
  menu.style.display = 'flex'
  state.isOpen = true
  timer = setTimeout(() => {
    menu.classList.add('is-open')
    menuBtn.classList.add('is-open')
  }, 200)
}

// Kill menu --------
function kill() {
  menu.classList.remove('is-open')
  menuBtn.classList.remove('is-open')
  document.documentElement.style.overflow = 'auto'
  state.isOpen = false
  menu.style.display = window.innerWidth >= 1024 ? 'flex' : 'none'
}

if (menu && menuBtn) {
  menuBtn.addEventListener('click', () => {
    if (state.isOpen) close()
    else open()
  })

  window.addEventListener('resize', () => {
    kill()
  })
}